export default __webpack_public_path__ + "static/media/certifiedSQL.5c388b5d.png";